import React from 'react'

export default function PaymentConfirmed() {
  return (
    <div>
      <div className="row-bot">
        <div className="text-border">
          Payment confirmed
        </div>
      </div>
    </div>
  )
}
